// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `drop-down-menu .drop-down-menu {
  top: 0;
  left: 0;
  box-sizing: border-box;
  position: fixed;
  z-index: 3;
  width: 100%;
  background-color: rgba(34, 34, 34, 0.95);
  display: flex;
  flex-direction: column;
}
drop-down-menu .drop-down-menu .header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: var(--large-spacing) var(--safe-area-right) var(--large-spacing) var(--safe-area-left);
  margin-top: max(var(--header-height), var(--safe-area-top));
}
drop-down-menu .drop-down-menu .header h4 {
  color: var(--primary-color);
  opacity: 0;
  transition: 0.1s;
  pointer-events: none;
}
drop-down-menu .drop-down-menu .header h4.show {
  opacity: 1;
  cursor: pointer;
  pointer-events: initial;
}
drop-down-menu .drop-down-menu .header h4:hover {
  color: var(--motes-dark-yellow);
}
drop-down-menu .drop-down-menu .drawer-content {
  overflow: scroll;
  scrollbar-width: none;
  flex: 1;
}
drop-down-menu .drop-down-menu .drawer-content::-webkit-scrollbar {
  display: none;
}
drop-down-menu .drop-down-menu .close-button {
  display: flex;
  margin: var(--large-spacing) var(--safe-area-right) var(--large-spacing) var(--safe-area-left);
  margin-bottom: calc(var(--large-spacing) + var(--safe-area-bottom) + var(--m-tabs-height));
}
drop-down-menu .drop-down-menu .close-button button {
  margin: 0;
  min-width: 150px;
}
drop-down-menu .overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
drop-down-menu .overlay.open {
  position: fixed;
  z-index: 2;
  pointer-events: auto;
}
@media only screen and (min-width: 900px) {
  drop-down-menu .drop-down-menu {
    height: 0;
    overflow: hidden;
    transition: 0.2s ease-out 0.2s;
    pointer-events: none;
  }
  drop-down-menu .drop-down-menu::after {
    content: "";
    border-bottom: 5px solid var(--primary-color);
    display: block;
    margin-top: 3px;
    transform: translateX(120%);
    transition: 0.3s 0s;
  }
  drop-down-menu .drop-down-menu .close-button, drop-down-menu .drop-down-menu .drawer-content {
    opacity: 0;
    transition: opacity 0.3s ease-out 0s;
  }
  drop-down-menu .drop-down-menu.open {
    height: min(100%, var(--header-height) + 700px);
    pointer-events: auto;
    transition: 0.2s ease-in 0.2s;
  }
  drop-down-menu .drop-down-menu.open::after {
    transition: 0.4s 0.3s;
    transform: translateX(0%);
  }
  drop-down-menu .drop-down-menu.open .close-button, drop-down-menu .drop-down-menu.open .drawer-content {
    opacity: 1;
    transition: opacity 0.2s ease-in 0.3s;
  }
}
@media only screen and (max-width: 900px) {
  drop-down-menu .drop-down-menu.full-screen-mobile {
    transform: translateY(-100%);
    transition: transform 0.3s;
  }
  drop-down-menu .drop-down-menu.full-screen-mobile.open {
    transform: translateY(0);
    pointer-events: auto;
    top: 0;
    bottom: var(--m-tabs-height);
    display: flex;
    flex-direction: column;
  }
  drop-down-menu .drop-down-menu.full-screen-mobile.open .drawer-content {
    flex: 1;
  }
  drop-down-menu .drop-down-menu:not(.full-screen-mobile) {
    height: 0;
    overflow: hidden;
    transition: 0.2s ease-out 0.2s;
    pointer-events: none;
  }
  drop-down-menu .drop-down-menu:not(.full-screen-mobile)::after {
    content: "";
    border-bottom: 5px solid var(--primary-color);
    display: block;
    margin-top: 3px;
    transform: translateX(120%);
    transition: 0.3s 0s;
  }
  drop-down-menu .drop-down-menu:not(.full-screen-mobile) .close-button, drop-down-menu .drop-down-menu:not(.full-screen-mobile) .drawer-content {
    opacity: 0;
    transition: opacity 0.3s ease-out 0s;
  }
  drop-down-menu .drop-down-menu:not(.full-screen-mobile).open {
    height: min(100%, var(--header-height) + 700px);
    pointer-events: auto;
    transition: 0.2s ease-in 0.2s;
  }
  drop-down-menu .drop-down-menu:not(.full-screen-mobile).open::after {
    transition: 0.4s 0.3s;
    transform: translateX(0%);
  }
  drop-down-menu .drop-down-menu:not(.full-screen-mobile).open .close-button, drop-down-menu .drop-down-menu:not(.full-screen-mobile).open .drawer-content {
    opacity: 1;
    transition: opacity 0.2s ease-in 0.3s;
  }
}
@media only screen and (max-width: 600px) {
  drop-down-menu .close-button button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/drop-down-menu/drop-down-menu.component.scss"],"names":[],"mappings":"AAEI;EACI,MAAA;EACA,OAAA;EACA,sBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,wCAAA;EACA,aAAA;EACA,sBAAA;AADR;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,8FAAA;EACA,2DAAA;AADZ;AAGY;EACI,2BAAA;EACA,UAAA;EACA,gBAAA;EACA,oBAAA;AADhB;AAGgB;EACI,UAAA;EACA,eAAA;EACA,uBAAA;AADpB;AAIgB;EACI,+BAAA;AAFpB;AAOQ;EACI,gBAAA;EACA,qBAAA;EACA,OAAA;AALZ;AAOY;EACI,aAAA;AALhB;AASQ;EACI,aAAA;EACA,8FAAA;EACA,0FAAA;AAPZ;AASY;EACI,SAAA;EACA,gBAAA;AAPhB;AAYI;EACI,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AAVR;AAYQ;EACI,eAAA;EACA,UAAA;EACA,oBAAA;AAVZ;AAsEI;EACI;IAtCA,SAAA;IACA,gBAAA;IACA,8BAAA;IACA,oBAAA;EA7BN;EA+BM;IACI,WAAA;IACA,6CAAA;IACA,cAAA;IACA,eAAA;IACA,2BAAA;IACA,mBAAA;EA7BV;EAgCM;IACI,UAAA;IACA,oCAAA;EA9BV;EAiCM;IACI,+CAAA;IACA,oBAAA;IACA,6BAAA;EA/BV;EAiCU;IACI,qBAAA;IACA,yBAAA;EA/Bd;EAkCU;IACI,UAAA;IACA,qCAAA;EAhCd;AACF;AA4CI;EAEQ;IAhEJ,4BAAA;IACA,0BAAA;EAsBN;EApBM;IACI,wBAAA;IACA,oBAAA;IACA,MAAA;IACA,4BAAA;IACA,aAAA;IACA,sBAAA;EAsBV;EApBU;IACI,OAAA;EAsBd;EAiCU;IAjDJ,SAAA;IACA,gBAAA;IACA,8BAAA;IACA,oBAAA;EAmBN;EAjBM;IACI,WAAA;IACA,6CAAA;IACA,cAAA;IACA,eAAA;IACA,2BAAA;IACA,mBAAA;EAmBV;EAhBM;IACI,UAAA;IACA,oCAAA;EAkBV;EAfM;IACI,+CAAA;IACA,oBAAA;IACA,6BAAA;EAiBV;EAfU;IACI,qBAAA;IACA,yBAAA;EAiBd;EAdU;IACI,UAAA;IACA,qCAAA;EAgBd;AACF;AAQI;EACI;IACI,WAAA;EANV;AACF","sourcesContent":["drop-down-menu {\n\n    .drop-down-menu {\n        top: 0;\n        left: 0;\n        box-sizing: border-box;\n        position: fixed;\n        z-index: 3;\n        width: 100%;\n        background-color: rgba(34,34,34,0.95);\n        display: flex;\n        flex-direction: column;\n\n        .header {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            margin: var(--large-spacing) var(--safe-area-right) var(--large-spacing) var(--safe-area-left);\n            margin-top: max(var(--header-height), var(--safe-area-top));\n\n            h4 {\n                color: var(--primary-color);\n                opacity: 0;\n                transition: 0.1s;\n                pointer-events: none;\n\n                &.show {\n                    opacity: 1;\n                    cursor: pointer;\n                    pointer-events: initial;\n                }\n\n                &:hover {\n                    color: var(--motes-dark-yellow);\n                }\n            }\n        }\n\n        .drawer-content {\n            overflow: scroll;\n            scrollbar-width: none; // Hide scrollbar in firefox\n            flex: 1;\n\n            &::-webkit-scrollbar {\n                display: none;\n            }\n        }\n\n        .close-button {\n            display: flex;\n            margin: var(--large-spacing) var(--safe-area-right) var(--large-spacing) var(--safe-area-left);\n            margin-bottom: calc(var(--large-spacing) + var(--safe-area-bottom) + var(--m-tabs-height));\n\n            button {\n                margin: 0;\n                min-width: 150px;\n            }\n        }\n    }\n\n    .overlay {\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n\n        &.open {\n            position: fixed;\n            z-index: 2;\n            pointer-events: auto;\n        }\n    }\n\n    @mixin slide-down {\n        transform: translateY(-100%);\n        transition: transform 0.3s;\n\n        &.open {\n            transform: translateY(0);\n            pointer-events: auto;\n            top: 0;\n            bottom: var(--m-tabs-height);\n            display: flex;\n            flex-direction: column;\n\n            .drawer-content {\n                flex: 1;\n            }\n        }\n    }\n\n    @mixin fade-down {\n        height: 0;\n        overflow: hidden;\n        transition: 0.2s ease-out 0.2s;\n        pointer-events: none;\n\n        &::after {\n            content: '';\n            border-bottom: 5px solid var(--primary-color);\n            display: block;\n            margin-top: 3px;\n            transform: translateX(120%);\n            transition: .3s .0s;\n        }\n\n        .close-button, .drawer-content {\n            opacity: 0;\n            transition: opacity 0.3s ease-out 0s;\n        }\n\n        &.open {\n            height: min(100%, calc(var(--header-height) + 700px));\n            pointer-events: auto;\n            transition: 0.2s ease-in 0.2s;\n\n            &::after {\n                transition: .4s .3s;\n                transform: translateX(0%);\n            }\n\n            .close-button, .drawer-content {\n                opacity: 1;\n                transition: opacity 0.2s ease-in 0.3s;\n            }\n        }\n    }\n\n    // Always use fade-down on large screens\n    @media only screen and (min-width: 900px) {\n        .drop-down-menu {\n            @include fade-down;\n        }\n    }\n\n    // Use slide-down or fade-down on small screens depending on input\n    @media only screen and (max-width: 900px) {\n        .drop-down-menu {\n            &.full-screen-mobile {\n                @include slide-down;\n            }\n            &:not(.full-screen-mobile) {\n                @include fade-down;\n            }\n        }\n    }\n\n    // Mobile view\n    @media only screen and (max-width: 600px) {\n        .close-button button {\n            width: 100%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
